export default "__VITE_ASSET__13ab12be__"